import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleBanner";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function RecipesViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [recipes, setRecipes] = useState({ data: [] });
  const [fetchedRecipe, setFetchedRecipe] = useState({
    recipe: null,
    recipeItems: [],
    packagingItems: [],
  });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getRecipes = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`recipes`, payload);
    setLoading(false);
    if (callResult.success) {
      setRecipes(callResult.data);
    } else {
      showErrorModal(callResult.data.message);
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const fetchRecipeByPlu = async function (plu) {
    const callResult = await makePostApiCall(`fetchRecipeByPLU/${plu}`, {});
    if (callResult.success) {
      setFetchedRecipe(callResult.data);
    }
    if (callResult.errorStatus === 401) {
      logout();
    }
  };

  const deleteRecipe = async function (id) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteRecipe/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getRecipes(null, 0);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteRecipe = function (recipe) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteRecipe(recipe.id)}
          message={`Are you sure you want to delete  ${recipe.recipe_name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteRecipe,
    emptyModal,
    fetchRecipeByPlu,
    getRecipes,
    loading,
    recipes,
    fetchedRecipe,
    setRecipes,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
  };
}
